export default "__VITE_ASSET__Bd0Uw$4I__"